import { Link } from 'react-router-dom';
import { FaCompass } from 'react-icons/fa';
import { ScreenState } from './ScreenState';
import { useLanguage } from '../../../Hooks/Contexts/Translate/useLanguageContext';

const BLOCK = 'LStudio__app_screen';

/*
    🔥 404

    ⚠️ El botón vuelve al inicio, NO al historial. Muchos 404 llegan
       desde un enlace externo o un marcador viejo: ahí "volver atrás"
       devuelve al usuario fuera del sitio.
*/

export const ScreenNotFound = ({
    title = null,
    description = null,
    homePath = '/',
    homeLabel = null,
    actions = null,
    isFullScreen = false,
}) => {

    const { useDataLanguage } = useLanguage();

    const TEXT = useDataLanguage.translations?.TEMPLATES?.screen ?? {};

    return (
        <ScreenState
            icon={<FaCompass />}
            code="404"
            tone="accent"
            title={title ?? TEXT.notFoundTitle}
            description={description ?? TEXT.notFoundText}
            isFullScreen={isFullScreen}
            actions={
                actions ?? (
                    <Link className={`${BLOCK}__button`} to={homePath}>{homeLabel ?? TEXT.goHome}</Link>
                )
            }
        />
    );
};
